import {
  mapRemove,
  mapSet,
  mapUpdateProperty
} from '../../components/helpers/immutable';
import {
  SET_CRONJOB_TIMER_ID,
  START_CRONJOB,
  STOP_CRONJOB
} from '../actions/cronJobs';

const cronJobs = (state, action) => {
  switch (action.type) {
    case START_CRONJOB:
      return {
        ...state,
        cronJobs: mapSet(state.cronJobs, action.cronJob.id, action.cronJob)
      };
    case SET_CRONJOB_TIMER_ID:
      return {
        ...state,
        cronJobs: mapUpdateProperty(state.cronJobs, action.id, {
          timerId: action.timerId
        })
      };
    case STOP_CRONJOB:
      return {
        ...state,
        cronJobs: mapRemove(state.cronJobs, action.id)
      };
    default:
      return state;
  }
};

export default cronJobs;
